<template>
    <div :class="['dropdownContainer', { openUpwards: openUpwards }]">
        <SearchBar class="optionSearch" searchIcon="true" v-bind:search="search"
            v-bind:searchCallback="(data) => { this.filterOptions(data) }"> </SearchBar>
        <div class="optionContainer">
            <div class="option">
                <button v-for="option in localOptions" v-bind:key="option.key ?? option.value"
                    @click="(event) => onOptionSelected(option, event)">
                    <!-- <div class="optionLayout">
                        <p class="plusIcon">+</p>
                        <p class="value">Option Value</p>
                    </div> -->
                    <div class="optionLayout">
                        <p class="plusIcon">+</p>
                        <p class="value"> {{ option.name }}</p>
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
//import * as Constants from "../../js/constants"
import SearchBar from "../pages/pageComps/Search.vue";

export default {
    components: {
        SearchBar
    },
    props: ["options", "searchCallback", "onOptionSelected", "openUpwards"],
    data() {
        return {
            search: "",
            localOptions: this.$props.options,
            selectedOption: null
        }
    },
    watch: {
        options: function (newVal) {
            console.log("New Options", newVal)
            this.localOptions = newVal
        }
    },
    methods: {
        filterOptions(data) {
            this.localOptions = this.$props.options.filter(
                item => item.name.toLowerCase().includes(data.toLowerCase())
            )

        }
    }

}
</script>

<style scoped>
.dropdownContainer {
    flex: 2;
    width: 100%;
    height: auto;
    background-color: white;
    z-index: 5;
}

.openUpwards {
    top: -175px;
    position: relative;
}

.openUpwards .optionContainer{
    top: -175px;
}

.openUpwards .optionSearch{
    top: -175px;
    position: relative;
}

.optionContainer {
    width: 100%;
    max-height: 150px;
    background-color: white;
    z-index: 5;
    padding: 4px 4px;
    overflow: scroll;
    position: relative;
}

.optionSearch {
    padding-top: 4px;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 8px !important;
    align-items: center;
    border-radius: 4px;
    width: initial;
    background-color: #F3F3F3;
    z-index: 5;

}

::placeholder {
    font-weight: 100;
    color: #F3F3F3;
}

.option {
    width: 100%;
}

.option button {
    width: 100%;

}

.optionLayout {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin: 0px 8px;
    padding: 8px 8px;
    border-radius: 4px;
    z-index: 5;

}

.optionLayout:hover {
    background-color: #6999911F;
    color: #699991;
    transition: 0.5s;
}

.plusIcon {
    flex: 1;
    align-self: center;
    border: 0;
}

.value {
    flex: 8;
    border: 0;
    font-weight: 400;
}
</style>